<template>
  <div class="list">
    <div class="topBar">
      <div class="subTitle" style="width:70%">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right: -10px;color:rgba(52,152,219,1);"
        ></i>
        佣金结算
        <div class="rutun">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div style="margin-left:4px" @click="geting()">刷新</div>
        </div>
      </div>
    </div>
    <noAccess v-if="showNoAccess"></noAccess>
    <div v-else style="width: 70%;margin: 0 auto">
     
      <div class="form-title">
        <div
          style="  display: flex;justify-content: space-between;;line-height: 46px;padding-left: 10px;padding-right: 10px;"
        >
          <div>筛选查询</div>
          <div>
            <el-select
              style="margin:0 10px"
              size="small"
              v-model="downloadNumber"
              placeholder="每页条数"
            >
              <el-option
                v-for="item in listNumber"
                :key="item.label"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <!-- <el-button size="small" @click="downloadOrderList()">导出订单</el-button> -->
          </div>
        </div>
      </div>
      <div style="background-color:#fff;width:100%" class="order-search-box">
        <el-row class="search" :gutter="10" style="height:60rpx">
            <el-col :span="2">
             <div class="label">店铺</div>
            </el-col>
            <el-col :span="6">
              <el-select v-model="s_shop_name" size="small" clearable  filterable placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.shop_id"
                  :label="item.shop_name"
                  :value="item.shop_id">
                </el-option>
              </el-select>
            </el-col>
          <el-col :span="3">
            <div class="label">订单编号:</div>
          </el-col>
          <el-col :span="4">
            <el-input v-model="orderCode" clearable size="small" placeholder="请输入订单编号"></el-input>
          </el-col>
          <el-col :span="3">
            <div class="label">下单时间:</div>
          </el-col>
          <el-col :span="4">
            <template>
              <div class="block">
                <el-date-picker
                  value-format="yyyy-MM-dd"
                  v-model="create_time"
                  size="small" 
                  clearable 
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </el-date-picker>
              </div>
            </template>
          </el-col>
          <el-col :span="6" align="center"></el-col>
        </el-row>
        <el-row class="search" :gutter="10" style="height:60rpx">
           <el-col :span="3">
             <div class="label">是否结算</div>
            </el-col>
            <el-col :span="15">
              <el-select v-model="is_share" size="small" clearable  filterable placeholder="请选择">
                <el-option
                  v-for="item in options2"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-col>
          <el-col :span="14" align="center">
            <div class="filtrate_seek_sousuo" @click="geting()">搜索</div>
          </el-col>
        </el-row>
      </div>

      <div class="filtrate_center">
        <div class="center_list_head">
          <div class="center_list_head_left">
            <div>
              <i class="fas fa-bars"></i>
            </div>
            <div>数据列表</div>
              
          </div>
        </div>
        <div class="center_list_center"></div>
      </div>
      <el-table :data="tableData" :summary-method="getSummaries" show-summary border style="width: 100%" ref="multipleTable" @selection-change="handleSelectionChange">
        <el-table-column type="selection" align="center" :selectable = filterCheck width="55"></el-table-column>
        <el-table-column prop="shop_name" width="80" label="店铺" align="center"></el-table-column>
        <el-table-column prop="orderCode" width="180" label="订单编号" align="center"></el-table-column>
        <el-table-column prop="mobile" label="用户" width="140" align="center"></el-table-column>
        <el-table-column prop="all_money" width="100" label="订单金额" align="center"></el-table-column>
        <el-table-column prop="share_rate" width="100" label="佣金比" align="center"></el-table-column>
        <el-table-column width="100" label="分成金额" align="center">
          <template slot-scope="scope">
             <span>{{ scope.row.all_money * scope.row.share_rate }}</span>
          </template>
        </el-table-column>
        <el-table-column  width="100" label="支付方式" align="center">
          <template slot-scope="scope">
              <span v-if="scope.row.pay_status == 1">已支付</span>
              <span v-else>未支付</span>
          </template>
        </el-table-column>
        <el-table-column :formatter="dateFormat" prop="create_time" label="下单时间" align="center"></el-table-column>
        <el-table-column width="80" label="是否结算" align="center">
            <template slot-scope="scope">
              <el-tag  v-if="scope.row.is_share == 1" size="small" type="success">已结算</el-tag>
                <el-tag v-else-if="scope.row.is_share == 2" size="small" type="danger">
                <el-tooltip class="item" effect="dark" :content="'作废原因：' + scope.row.share_reson" placement="top">
                  <span>已作废</span>
                </el-tooltip>
                </el-tag>
              <el-tag type="info" size="small" v-else>未结算</el-tag>
            </template>   
        </el-table-column>
       
        <el-table-column
          v-if="finance_check == '1'"
          prop="finance_check"
          label="财务审核"
          align="center"
        ></el-table-column>
        <el-table-column label="操作" width="200" align="center" name="bianji">
          <template slot-scope="scope" style="display:flex;padding:0;margin:0">
            <router-link
              class="button1"
              target="_blank"
              :to="'./d_viewOrde/'+ scope.row.id + '/' + 1"
            >查看订单</router-link>
           <button v-if="scope.row.is_share == 0" class="button1" @click="mutipShare(scope.row.id)">立即结算</button>
           <button v-if="scope.row.is_share == 0" class="button1" @click="abandonShare(scope.row.id)">作废结算</button>
          </template>
        </el-table-column>
      </el-table>
      
      <div class="page_box clearfix" >
        <el-button @click="mutipShare('muti')" size="small">批量结算</el-button>
        <div class="page">
          <el-pagination
            background
            layout="total, prev, pager, next"
            :total="total"
            :page-size="limit"
            @current-change="setPage"
          ></el-pagination>
        </div>
      </div>
    </div>
    
       

  </div>
</template>

<script>
import "../../assets/all.css";
export default {
  name: "list",
  data() {
    return {
      order_hint_yuyin: false,
      order_hint: false,
      time: null,
      serve: this.$store.state.serve,
      showNoAccess: false,
      order: "",
      order_date: "",
      id: "",
      dialogFormVisible1: false,
      dialogFormVisible2: false,
      number: "",
      name: "",
      create_time: "",
      username: this.$cookies.get("username"),
      token: this.$cookies.get("token"),
      page: null,
      total: 0,
      limit: 15,
      resType: null,
  
      tableData: [],
      finance_check: 0,
      purchaseData: [],
      purchaseForm: [],
      sendData: [],
      restaurants: [],
      listNumber: [
        { value: 10, label: "10条" },
        { value: 30, label: "30条" },
        { value: 50, label: "50条" },
        { value: 100, label: "100条" },
        { value: 500, label: "500条" },
        { value: 1, label: "全部" }
      ],
      downloadType: [
        { value: 1, label: "详细信息" },
        { value: 2, label: "简洁信息" }
      ],
      downloadNumber: 15,
      true_value: false,
      orderCode: "",
      sale_name: "",
      mobile_name: "",
      download_type: "",
      s_shop_name: '',
      is_share: '',
      options: [],
      options2:[
        {
          id:'',
          name: '全部'
        },
        {
          id:0,
          name: '未结算'
        },{
          id:1,
          name: '已结算'
        },{
          id:2,
          name: '已作废'
        },
      ],
      multipleSelection: []
    };
  },
  created() {
    
    this.$store.state.topActiveId = 10;
    this.$store.state.leftTitle = "佣金结算";
    this.geting();
    this.shopSearchList();
  },
  watch: {
    //监听全选状态
    // selectAll(v) {
    //   if (v == false) {
    //     this.$refs.multipleTable.clearSelection();
    //   } else {
    //     this.$refs.multipleTable.clearSelection();
    //     this.$refs.multipleTable.toggleAllSelection();
    //   }
    // },
    order_hint_yuyin: {
      handler(newName, oldName) {},
      immediate: true
    }
  },
  beforeDestroy() {
    if (this.time) {
      clearInterval(this.time);
    }
  },
  methods: {

    alert_success(message) {
      this.$message({
        type: "success",
        message: message,
        offset: 200
      });
    },
    alert_error(message) {
      this.$message({
        type: "error",
        message: message,
        offset: 200
      });
    },
    downloadOrderList() {
      var where = {
        token: this.token,
        username: this.username,
        create_time: this.create_time,
        status: this.resType,
        true_value: this.true_value,
        sale_name: this.sale_name,
        limit: this.downloadNumber
      };
      if (this.downloadNumber == "") {
        this.alert_error("请选择要导出的条数");
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: "正在下载..",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      this.axios
        .get(this.serve + "/admin/download_order_list", {
          params: where,
          responseType: "blob",
          onDownloadProgress: function(progressEvent) {}
        })
        .then(res => {
          if(res.data.code == '403'){
              this.$message.error(res.data.code);
          }
          if (res.data.type == "text/html") {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            let fileName = "宝枫林订单详情列表.xlsx";
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            this.loading = false;

            this.$message({
              type: "success",
              message: "导出成功成功",
              offset: 200
            });
          } else {
  
            this.$message({
              showClose: true,
              message: "没有权限导出或导出失败请重新操作",
              type: "error",
              offset: 200
            });
          }
          loading.close();
        })
        .catch(er => {
          this.loading = false;
          loading.close();
          this.$message({
            showClose: true,
            message: "导出失败请重新操作",
            type: "error",
            offset: 200
          });
        });
    },
    supplierSelect(item) {},
    open4() {
      //错误时返回的息状态
      this.$message({
        //成功时 返回的状态
        message: this.msg1,
        type: "error",
        offset: 200
      });
    },
    open() {
      this.$message({
        //成功时 返回的状态
        message: "发货成功",
        type: "success",
        offset: 200
      });
    },
    setPage(v) {
      //分页
      this.page = v;
      this.geting(v);
      //this.selectAll = false;
    },
    geting(page) {
      //请求数据
      var that = this;
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");
      const loading = this.$loading({
        lock: true,
        text: "正在加载...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      var formData = {
        page: page ? page : this.page,
        token: this.token,
        username: this.username,
        orderCode: this.orderCode,
        create_time: this.create_time,
        shop_id: this.s_shop_name,
        is_share: this.is_share,
        is_shop: 1,
        limit: this.downloadNumber
      };
      this.limit =this.downloadNumber;
      this.axios
        .get(this.serve + "/admin/order_list2", {
          params: formData
        })
        .then(res => {
          that.tableData = [];
          var json = res.data.data;
          if (res.data.status == "success") {
            that.total = res.data.data.total;
            that.page = res.data.data.now_page;
            var count = res.data.data;
            that.tableData = json.results;
          } else {
            if (res.data.msg == "无权访问") {
              this.showNoAccess = true;
            }
            this.tableData = [];
            this.total = 0;
            this.now_page = 1;
          }
          loading.close();
        });
    },
    filterCheck (row) {  //筛选多选只能是未结算的条件才可已进行勾选
      if(row.is_share == 0){
        return true;
      }
    },
    abandonShare (v) {
        this.$prompt('此操作将使该订单不作为对入驻商的佣金计算, 是否继续?', '作废订单结算', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputType: 'textarea',
          inputPattern: /\S/,
          center: true,
          inputErrorMessage: '请填写作废该订单的原因！'
        }).then(({ value }) => {

          this.axios.get(this.serve + "/admin/abandonShare",{  
               params: {
                token: this.token,
                username: this.username,
                id: v,
                reson: value
              } 
           }).then(res => {
              if(res.data.status == 'success'){
                  this.$message({
                    type: 'success',
                    message: '操作成功！'
                  });   
                  window.location.reload();
              }else if(res.data.code == '403'){
                this.$message.error(res.data.msg);  
              }
           })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });       
        });
    },
    mutipShare (v){ //批量进行佣金结算
      
      if(v !='muti' && v > 0){
        this.multipleSelection.push(v);
      }
      var that = this;
      if(this.multipleSelection.length <= 0){
        this.$message.error('请选择要结算的订单在进行批量操作！');
      }else{
        this.$confirm('此操作将使选中的订单更改为已结算状态, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var data = Object.assign({},that.multipleSelection);
          var ids = [];
          if(v !='muti' && v > 0){ //单个执行
              ids.push(v);
          }else{  //批量操作
            for(var key in data){
              ids.push(data[key]['id']);
            }
          }
          this.axios.get(this.serve + "/admin/mutiShare",{  //批量操作
              params: {
                token: this.token,
                username: this.username,
                ids: ids.join(',')
              } 
           }).then(res => {
              if(res.data.status == 'success'){
                this.$message({
                  type: 'success',
                  message: '操作成功！'
                });   
                window.location.reload();
              }else if(res.data.code == '403'){
                this.$message.error(res.data.msg);  
              }
           })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          });          
        });
      }
    },
    shopSearchList() {
      this.axios
        .get(this.serve + "/admin/shopSearchList", {
          params: {
            username: this.username,
            token: this.token
          }
        })
        .then(res => {
     
          if (res.data.status == "success") {
            
            var arr = [];
            for(var vs of res.data.data){
               arr.push(vs);
            }
            this.options = arr;
          }
        });
    },
    dateFormat(row, column){ // 时间戳格式化
        const daterc = row[column.property]
        if(daterc!=null){
        var date = new Date(parseInt(daterc)*1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var year = date.getFullYear(),
            month = ("0" + (date.getMonth() + 1)).slice(-2),
            sdate = ("0" + date.getDate()).slice(-2),
            hour = ("0" + date.getHours()).slice(-2),
            minute = ("0" + date.getMinutes()).slice(-2),
            second = ("0" + date.getSeconds()).slice(-2);
        // 拼接
        var result = year + "/"+ month +"/"+ sdate+"/" + hour+":"+minute+":"+second ;
        // 返回
        return result;
        }
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getSummaries(param) { // 表格列求和
        const { columns, data } = param
        const sums = []
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '合计'
          } 
          // index >= 3 || index <= 11 是你需要计算的列
          // 当然也可以指定一个或者多个列
          // index === 2 || index === 3 这样值求和第二个与第三个列
          else if (index == 4 || index ==6) {
            if(index == 4){
              const values = data.map(item => item['all_money'])
              sums[index] = eval(values.join("+"));
            }else if(index==6){
              const values3 = data.map(item =>item['all_money'] * item['share_rate'])
              sums[index] =Math.floor( eval(values3.join("+")) *1000)/1000;
            }
          } else {
            sums[index] = ''
          }
        })
        return sums
      }
  }
};
</script>
<style lang="scss">
.order-search-box{
  width: 100%;
}
.list {
  .order-search-box {
    width: 100%;
    height: 130px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
  }
  background: #f5f5f5;
  color: #333;
  padding-bottom: 100px;
  .topBar {
    margin-bottom: 40px;
  }
  .filtrate_seek_sousuo {
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(102, 102, 102, 1);
    width: 74px;
    height: 28px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    position: absolute;
    right: 97px;
    top: 29px;
    cursor: pointer;
  }
  .el-pagination {
    text-align: left;
  }
  .filtrate_seek_sousuo:hover {
    background-color: #0099ff;
    color: #fff;
  }

  .subTitle {
    width: 70%;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
    .rutun {
      width: 78px;
      height: 28px;
      background: #fff;
      border: 1px solid rgba(221, 221, 221, 1);
      text-align: center;
      margin-top: 9px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
    }
    .rutun:hover {
      color: #0099ff;
    }
  }
  .filtrate_center {
    margin-top: 19px;
    border-left: 1px solid rgba(221, 221, 221, 1);
    border-top: 1px solid rgba(221, 221, 221, 1);
    border-right: 1px solid rgba(221, 221, 221, 1);
  }
  .button1 {
    // border: 0;
    border: none;
    outline: none;
    background: none;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(51, 51, 51, 1);
    line-height: 18px;
    cursor: pointer;
  }
  .button1:hover {
    color: #0099ff;
  }
  .search {
    height: 60px;
    display: flex;
    justify-content: center;
  }
  .cell {
    color: #606266 !important;
  }
  .center_list_head {
    width: 100%;
    height: 46px;
    // background: orange;
    display: flex;
    justify-content: space-between;
    .center_list_head_left {
      display: flex;
      align-items: center;
      > div {
        margin-left: 10px;
      }
    }
    .center_list_head_rig {
      width: 100px;
      height: 30px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      font-size: 12px;
      font-family: "MicrosoftYaHeiLight";
      font-weight: 300;
      color: rgba(153, 153, 153, 1);
      margin: 7px 30px 0 0;
      line-height: 30px;
      text-align: center;
      cursor: pointer;
    }
    .center_list_head_rig:hover {
      color: #0099ff;
    }
  }

  .menu1 {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    .btn3 {
      margin-right: 0;
      i {
        font-style: normal;
        color: #f64e62;
      }
    }
    .btn3:hover i {
      color: #fff;
    }
    .active i {
      color: #fff;
    }
  }
  .search .el-col {
    line-height: 80px;
  }
  .label {
    text-align: right;
    padding-right: 10px;
    font-size: 14px;
  }
  .table {
    background-color: #fff;
    padding: 10px 20px;
    .el-tree-node {
      font-size: 16px;
      padding: 5px 0;
    }
  }
  .el-table_1_column_3 .cell {
    overflow: hidden;
    text-align: center;
  }
}
.muti-share{
  float: right;
}
</style>